import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Mousewheel } from "./mousewheel-C-gtMpkm.js";
import { t as Navigation } from "./navigation-BSfLh-wX.js";
//#region src/scripts/extenders/ugc-slider.js
var createSlider = (slider) => new Swiper(slider, {
	modules: [Mousewheel, Navigation],
	slidesPerView: Number(slider.dataset.spvm),
	spaceBetween: 16,
	watchOverflow: true,
	breakpoints: { 768: {
		slidesPerView: Number(slider.dataset.spvd),
		spaceBetween: 24
	} },
	navigation: {
		nextEl: slider.querySelector(".swiper-button-next"),
		prevEl: slider.querySelector(".swiper-button-previous")
	}
});
var UgcSliderElement = class extends HTMLElement {
	connectedCallback() {
		const slider = this.querySelector(".swiper");
		if (!slider) throw new Error("UGC slider container is missing");
		createSlider(slider);
	}
};
if (customElements.get("ugc-swiper") === void 0) customElements.define("ugc-swiper", UgcSliderElement);
//#endregion
